import { LocalStorageCompatible } from './local-storage-compatible';
import { isLocalStorageV17, LocalStorageV17 } from './local-storage-v17';
import { upgrade as upgradeFromPrevious } from './local-storage-v17.upgrade';
import { LocalStorageV18 } from './local-storage-v18';

/*
 * NOTE: Create new migration files only when you need to remove or edit existing field. Do not create new migration file for adding new field.
 */
export async function upgrade(raw: LocalStorageCompatible): Promise<LocalStorageV18> {
  const input: LocalStorageV17 = isLocalStorageV17(raw) ? raw : await upgradeFromPrevious(raw);
  const { data } = input;

  // Drop field sideBarsState.
  const { sideBarsState: _removed, ...rest } = data as LocalStorageV17['data'] & {
    sideBarsState?: any;
  };

  return {
    version: 18,
    data: {
      ...rest,
    },
  };
}
